import { render, staticRenderFns } from "./ValProductosEdit.vue?vue&type=template&id=72eeaa6c&"
import script from "./ValProductosEdit.vue?vue&type=script&lang=js&"
export * from "./ValProductosEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports